import { type FC } from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import qs from "qs";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { CountryAccessesFilter } from "./CountryAccessesFilter";
import { CountryAccessesList } from "./CountryAccessesList";
import { CreateCountryAccessDialog } from "./CreateCountryAccessDialog";
import { EditCountryAccessDialog } from "./EditCountryAccessDialog";

export const CountryAccesses: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { tab, id: countryAccessId } = qs.parse(searchParams.toString(), {
    ignoreQueryPrefix: true,
  }) as { tab?: string; id?: string };

  const handleEdit = (id: string) => {
    searchParams.set("tab", "edit");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const handleCreate = () => {
    searchParams.set("tab", "create");
    setSearchParams(searchParams);
  };

  const handleCloseCreateDialog = () => {
    searchParams.delete("tab");
    setSearchParams(searchParams);
  };

  const handleCloseEditDialog = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <CountryAccessesFilter onCreate={handleCreate} />
        <CountryAccessesList onEdit={handleEdit} />
      </Stack>

      <CreateCountryAccessDialog
        open={tab === "create"}
        onClose={handleCloseCreateDialog}
        onCompleted={handleCloseCreateDialog}
      />

      <EditCountryAccessDialog
        open={tab === "edit"}
        countryAccessId={countryAccessId ?? null}
        onClose={handleCloseEditDialog}
        onCompleted={handleCloseEditDialog}
      />
    </FilterProvider>
  );
};
